<template>
  <div class="navbar-collapse">
    <ul class="navbar-nav me-auto w-100">
      <li>
        <!-- {{ $auth.user }} -->
        <div class="profile" v-if="$auth.user">
          <div class="detail-cls-lnk sub-heading-primary">
            <h5 class="">{{ $t('Welcome', { msg: $auth.user.data ? $auth.user.data.first_name : $auth.user.first_name })
            }}!</h5>
            <p>{{ $auth.user.data ? $auth.user.data.mobile_number : $auth.user.mobile_number }}</p>
          </div>
          <div class="edit-cls-lnk">
            <router-link v-if="$auth.user" to="/profile" v-slot="{ href, navigate, isActive }">
      <li class="text-end d-flex flex-column bg-none" :class="[isActive ? 'nav-item active' : 'nav-item']"
        data-bs-dismiss="offcanvas">
        <button
          class="navbar-toggler navbar-toggler-right close-btn border-0 d-inline-flex d-sm-none ms-auto mb-sm-0 mb-2"
          type="button" data-bs-dismiss="offcanvas" aria-label="Close"><span><i
              class="fas fa-times"></i></span></button>
        <a class="nav-link mybtn" :href="href" @click="navigate">
          <span class="healthicons--ui-user-profile"></span></a>

      </li>
      </router-link>
  </div>
  </div>
  <div class="guest align-items-center" v-if="!$auth.user">
    <div class="guest-cls">
      <h6 class="fw-semibold">{{ $t('Welcome Guest') }} !</h6>
    </div>
    <div class="login-cls-lnk">
      <router-link v-if="!$auth.user" to="/sign-in" v-slot="{ href, navigate, isActive }">
        <li :class="[isActive ? 'nav-item active' : 'nav-item']">
          <div data-bs-dismiss="offcanvas" class="d-flex align-items-center">
            <a class="nav-link me-2" :href="href" @click="navigate">
              {{ $t('Sign In') }}
            </a>
            <button
              class="navbar-toggler navbar-toggler-right close-btn border-0 d-inline-flex d-sm-none ms-auto mb-sm-0"
              type="button" data-bs-dismiss="offcanvas" aria-label="Close"><span><i
                  class="fas fa-times"></i></span></button>
          </div>
        </li>
      </router-link>
    </div>
  </div>
  </li>
  <router-link to="/" v-slot="{ href, navigate, isActive }">
    <li :class="[isActive ? 'nav-item active' : 'nav-item']">
      <div data-bs-dismiss="offcanvas">
        <a class="nav-link" :href="href" @click="navigate">
          <span class="solar--home-2-bold | theme_ic"></span>
          {{ $t('Home') }}
        </a>
      </div>
    </li>
  </router-link>

  <router-link v-if="$auth.user && $auth.setting && $auth.setting.subscription_status == true" to="/manage-subscription"
    v-slot="{ href, navigate, isActive }">
    <li :class="[isActive ? 'nav-item active' : 'nav-item']">
      <div data-bs-dismiss="offcanvas">
        <a class="nav-link" :href="href" @click="navigate">
          <span class="stash--data-date-solid | theme_ic"></span>
          {{ $t('My Subscription') }}
        </a>
      </div>
    </li>
  </router-link>
  <router-link v-if="$auth.user && $auth.setting && $auth.setting.client_wallet_status == true" to="/wallet"
    v-slot="{ href, navigate, isActive }">
    <li :class="[isActive ? 'nav-item active' : 'nav-item']">
      <div data-bs-dismiss="offcanvas">
        <a class="nav-link" :href="href" @click="navigate">
          <span class="si--wallet-detailed-fill | theme_ic"></span>
          {{ $t('My Wallet') }}
          <!-- <div class="wallet-bal"><span v-html="$auth.setting.currency" class="currency"></span>{{ mywalletAmount }}</div> -->
          <div class="wallet-bal ms-auto fw-bold"><span v-html="$auth.setting.currency" class="currency"></span>{{
            walletAmount }}
          </div>
        </a>
      </div>
    </li>
  </router-link>
  <router-link v-if="$auth.user" to="/orders" v-slot="{ href, navigate, isActive }">
    <li :class="[isActive ? 'nav-item active' : 'nav-item']">
      <div data-bs-dismiss="offcanvas">
        <a class="nav-link" :href="href" @click="navigate">
          <!-- <span class="hugeicons--sending-order | theme_ic"></span>-->
          <span class="material-symbols--order-approve | theme_ic"></span>
          {{ $t('Orders') }}
        </a>
      </div>
    </li>
  </router-link>

  <router-link v-if="$auth.user" to="/address" v-slot="{ href, navigate, isActive }">
    <li :class="[isActive ? 'nav-item active' : 'nav-item']">
      <div data-bs-dismiss="offcanvas">
        <a class="nav-link" :href="href" @click="navigate">
          <span class="weui--location-filled | theme_ic"></span>
          {{ $t('Delivery Address') }}
        </a>
      </div>
    </li>
  </router-link>



  <router-link to="/promo-code" v-slot="{ href, navigate, isActive }">
    <li :class="[isActive ? 'nav-item active' : 'nav-item']">
      <div data-bs-dismiss="offcanvas">
        <a class="nav-link" :href="href" @click="navigate">
          <span class="bxs--offer | theme_ic"></span>
          {{ $t('Promocode') }}
        </a>
      </div>
    </li>
  </router-link>
  <router-link to="/faq" v-slot="{ href, navigate, isActive }">
    <li :class="[isActive ? 'nav-item active' : 'nav-item']">
      <div data-bs-dismiss="offcanvas">
        <a class="nav-link" :href="href" @click="navigate">
          <span class="solar--question-circle-bold | theme_ic"></span>
          {{ $t('FAQ') }}
        </a>
      </div>
    </li>
  </router-link>



  <router-link to="/pages" v-slot="{ href, navigate, isActive }">
    <li :class="[isActive ? 'nav-item active' : 'nav-item']" data-bs-dismiss="offcanvas">
      <div data-bs-dismiss="offcanvas">
        <a class="nav-link" :href="href" @click="navigate">
          <span class="material-symbols--privacy-tip-rounded | theme_ic"></span>
          {{ $t('Privacy & Terms') }}
        </a>
      </div>
    </li>
  </router-link>
  <router-link to="/support" v-slot="{ href, navigate, isActive }" v-if="nosupport">
    <li :class="[isActive ? 'nav-item active' : 'nav-item']">
      <div data-bs-dismiss="offcanvas">
        <a class="nav-link" :href="href" @click="navigate">
          <span class="mingcute--phone-call-fill | theme_ic"></span>
          {{ $t('Support') }}
        </a>
      </div>
    </li>
  </router-link>

  <router-link v-if="$auth.user" to="/report-bug" v-slot="{ href, navigate, isActive }">
    <li :class="[isActive ? 'nav-item active' : 'nav-item']">
      <div data-bs-dismiss="offcanvas">
        <a class="nav-link" :href="href" @click="navigate">
          <span class="material-symbols--feedback-rounded | theme_ic"></span>
          {{ $t('Feedback') }}
        </a>
      </div>
    </li>
  </router-link>
  <li class="nav-item logout-nav" @click="LogOut">
    <div data-bs-dismiss="offcanvas">
      <a class="nav-link" v-if="$auth.user">
        <span class="solar--logout-2-bold"></span>
        {{ $t('Sign Out') }}</a>
    </div>
  </li>
  </ul>
  <div class="sidebar-footer pb-3">
    <!-- <div class="store-btns d-flex align-items-center mt-4 justify-content-center gap-lg-3 gap-2">
      <div data-bs-dismiss="offcanvas">
        <a v-if="$auth.setting && $auth.setting.android_customer_app_url && $auth.setting.android_customer_app_url != 'undefined' && $auth.setting.android_customer_app_url != 'null'"
          :href="$auth.setting.android_customer_app_url" target="_blank" class="text-center">
          <img v-lazy="require('@/assets/images/google-play.png')" />
        </a>
      </div>
      <div data-bs-dismiss="offcanvas">
        <a v-if="$auth.setting && $auth.setting.ios_customer_app_url && $auth.setting.ios_customer_app_url != 'undefined' && $auth.setting.ios_customer_app_url != 'null'"
          :href="$auth.setting.ios_customer_app_url" target="_blank" class="text-center me-2">
          <img v-lazy="require('@/assets/images/app-store.png')" />
        </a>
      </div>
    </div> -->
    <!-- <div class="sidebar-footer-logo | px-5 py-2 text-center"
      v-if="$auth && $auth.setting && $auth.setting.show_contact_developer == 'Yes'"> -->

    <div class="px-5 py-2 text-center" v-if="$auth && $auth.setting && $auth.setting.show_contact_developer == 'Yes'">
      <a target="_blank"
        :href="`https://www.deonde.co?utm_source=website&utm_medium=customer&utm_campaign=${$auth.getAppName()}`">
        <svg width="110" height="36" viewBox="0 0 110 36" fill="none" xmlns="http://www.w3.org/2000/svg">
          <path fill-rule="evenodd" clip-rule="evenodd"
            d="M13.8101 31.3995L13.8072 31.3973L13.8001 31.3917L13.7748 31.3719C13.7532 31.3547 13.722 31.3301 13.6818 31.2979C13.6016 31.2338 13.4856 31.14 13.3391 31.0191C13.0462 30.7773 12.6305 30.4263 12.1329 29.9839C11.1391 29.1006 9.81076 27.8464 8.47865 26.3663C7.14987 24.8898 5.79527 23.1643 4.76759 21.3374C3.74591 19.5211 3 17.521 3 15.5177C3 12.463 4.21347 9.53346 6.37346 7.37346C8.53346 5.21347 11.463 4 14.5177 4C17.5725 4 20.502 5.21347 22.662 7.37346C24.8219 9.53346 26.0354 12.463 26.0354 15.5177C26.0354 17.521 25.2896 19.5211 24.2678 21.3374C23.2402 23.1643 21.8856 24.8898 20.5568 26.3663C19.2247 27.8464 17.8963 29.1006 16.9026 29.9839C16.4049 30.4263 15.9892 30.7773 15.6963 31.0191C15.5498 31.14 15.4338 31.2338 15.3537 31.2979C15.3135 31.3301 15.2823 31.3547 15.2606 31.3719L15.2354 31.3917L15.2283 31.3973L15.2261 31.3989C15.2261 31.3989 15.2248 31.4 14.5177 30.4908L15.2248 31.4C14.8089 31.7234 14.226 31.723 13.8101 31.3995ZM14.5177 30.4908L13.8101 31.3995C13.8101 31.3995 13.8106 31.4 14.5177 30.4908Z"
            fill="#F47342" />
          <mask id="mask0_1011_1226" style="mask-type:alpha" maskUnits="userSpaceOnUse" x="3" y="4" width="24"
            height="28">
            <path fill-rule="evenodd" clip-rule="evenodd"
              d="M13.8101 31.3995L13.8072 31.3973L13.8001 31.3917L13.7748 31.3719C13.7532 31.3547 13.722 31.3301 13.6818 31.2979C13.6016 31.2338 13.4856 31.14 13.3391 31.0191C13.0462 30.7773 12.6305 30.4263 12.1329 29.9839C11.1391 29.1006 9.81076 27.8464 8.47865 26.3663C7.14987 24.8898 5.79527 23.1643 4.76759 21.3374C3.74591 19.5211 3 17.521 3 15.5177C3 12.463 4.21347 9.53346 6.37346 7.37346C8.53346 5.21347 11.463 4 14.5177 4C17.5725 4 20.502 5.21347 22.662 7.37346C24.8219 9.53346 26.0354 12.463 26.0354 15.5177C26.0354 17.521 25.2896 19.5211 24.2678 21.3374C23.2402 23.1643 21.8856 24.8898 20.5568 26.3663C19.2247 27.8464 17.8963 29.1006 16.9026 29.9839C16.4049 30.4263 15.9892 30.7773 15.6963 31.0191C15.5498 31.14 15.4338 31.2338 15.3537 31.2979C15.3135 31.3301 15.2823 31.3547 15.2606 31.3719L15.2354 31.3917L15.2283 31.3973L15.2261 31.3989C15.2261 31.3989 15.2248 31.4 14.5177 30.4908L15.2248 31.4C14.8089 31.7234 14.226 31.723 13.8101 31.3995ZM14.5177 30.4908L13.8101 31.3995C13.8101 31.3995 13.8106 31.4 14.5177 30.4908Z"
              fill="#F47342" />
          </mask>
          <g mask="url(#mask0_1011_1226)">
            <path
              d="M14.3922 19.2442L23.7359 10.1981L29.741 9.08057L29.456 26.6897L22.4923 33.4316L9.13361 33.2154L1.02625 24.8413L10.7226 15.4538L14.3922 19.2442Z"
              fill="url(#paint0_linear_1011_1226)" />
          </g>
          <g filter="url(#filter0_d_1011_1226)">
            <path
              d="M9.91064 20.7391L18.5105 12.1392L9.91064 20.7391ZM18.5105 12.1392H10.7706H18.5105ZM18.5105 12.1392V19.8791V12.1392Z"
              fill="#0A102F" />
            <path d="M9.91064 20.7391L18.5105 12.1392M18.5105 12.1392H10.7706M18.5105 12.1392V19.8791" stroke="#0A102F"
              stroke-width="2.17557" stroke-linecap="round" stroke-linejoin="round" />
          </g>
          <path
            d="M98.1228 26.1347L106.276 24.5467C106.439 24.515 106.555 24.3704 106.55 24.2048C106.522 23.1898 106.272 22.2746 105.792 21.4678C105.327 20.6643 104.691 20.0339 103.887 19.5817C103.094 19.1278 102.205 18.9038 101.228 18.9038C100.186 18.9038 99.2438 19.141 98.4094 19.6226C97.5771 20.103 96.921 20.7754 96.4438 21.6329L96.4438 21.6329L96.4418 21.6366C95.9772 22.4969 95.7485 23.4643 95.7485 24.5309C95.7485 25.601 95.9919 26.5711 96.4854 27.4326C96.9782 28.2929 97.6694 28.9703 98.5525 29.4617L98.5525 29.4617L98.5561 29.4637C99.4422 29.9427 100.448 30.1779 101.565 30.1779C102.435 30.1779 103.239 30.0254 103.971 29.7153C104.704 29.4044 105.322 28.9499 105.819 28.3524C105.925 28.2247 105.924 28.0389 105.815 27.9135L105.024 27.0024C104.959 26.9279 104.865 26.8853 104.766 26.8857C104.667 26.8862 104.574 26.9297 104.51 27.0049C104.163 27.4127 103.738 27.7248 103.232 27.9423C102.737 28.1475 102.19 28.2524 101.584 28.2524C100.682 28.2524 99.9209 28.0307 99.2866 27.6001C98.765 27.2275 98.3772 26.7418 98.1228 26.1347ZM99.4414 21.2586L99.4414 21.2587L99.4435 21.2574C99.9673 20.9474 100.559 20.7897 101.228 20.7897C102.09 20.7897 102.799 21.0486 103.378 21.557L103.377 21.5571L103.38 21.5596C103.883 21.991 104.223 22.5265 104.4 23.1756L97.7907 24.4604C97.7906 24.4511 97.7906 24.4416 97.7906 24.4319C97.7906 23.7001 97.9388 23.0702 98.2248 22.5325C98.5263 21.9772 98.9315 21.5556 99.4414 21.2586Z"
            fill="#F47342" stroke="#F47342" stroke-width="0.677734" stroke-linejoin="round" />
          <path
            d="M94.49 15.9575C94.49 15.7704 94.3383 15.6187 94.1512 15.6187H92.7486C92.5615 15.6187 92.4098 15.7704 92.4098 15.9575V20.3458C92.0643 19.996 91.6691 19.7087 91.2248 19.4857C90.5 19.1021 89.6885 18.9138 88.7978 18.9138C87.7698 18.9138 86.8298 19.1508 85.9854 19.6296C85.1392 20.0963 84.4755 20.7622 83.9978 21.6206C83.5189 22.4814 83.2834 23.4561 83.2834 24.5358C83.2834 25.6155 83.5189 26.5902 83.9978 27.4509C84.4754 28.3091 85.1386 28.981 85.9835 29.4606C86.8284 29.9402 87.7691 30.1776 88.7978 30.1776C89.716 30.1776 90.5489 29.9821 91.2884 29.5836C91.7346 29.3473 92.1283 29.0484 92.469 28.6884V29.7398C92.469 29.9269 92.6207 30.0786 92.8079 30.0786H94.1512C94.3383 30.0786 94.49 29.9269 94.49 29.7398V15.9575ZM91.9581 26.4892L91.9581 26.4891L91.9555 26.4941C91.6554 27.0591 91.2391 27.4932 90.7034 27.8035C90.1796 28.1014 89.5867 28.2532 88.9164 28.2532C88.2331 28.2532 87.6269 28.1014 87.0899 27.8035C86.5678 27.4935 86.1503 27.059 85.8364 26.4916C85.5372 25.9271 85.3835 25.2779 85.3835 24.5358C85.3835 23.7936 85.5372 23.1445 85.8364 22.58C86.1505 22.0122 86.5678 21.585 87.0888 21.2884L87.0888 21.2884L87.091 21.2872C87.628 20.9764 88.2337 20.8183 88.9164 20.8183C89.5847 20.8183 90.1762 20.9758 90.6994 21.2855L90.6993 21.2856L90.7072 21.29C91.2406 21.5869 91.6558 22.0131 91.9555 22.5775L91.9555 22.5775L91.9581 22.5824C92.2697 23.1465 92.4295 23.7947 92.4295 24.5358C92.4295 25.2768 92.2697 25.925 91.9581 26.4892Z"
            fill="#F47342" stroke="#F47342" stroke-width="0.677734" stroke-linejoin="round" />
          <path
            d="M77.3784 19.2427C78.6945 19.2427 79.738 19.6267 80.5091 20.3949C81.2934 21.1498 81.6856 22.2556 81.6856 23.7125V29.7715H80.2698V23.8515C80.2698 22.7655 79.9973 21.9378 79.4522 21.3683C78.9072 20.7988 78.1295 20.5141 77.1191 20.5141C75.9891 20.5141 75.0918 20.8518 74.4271 21.5272C73.7757 22.1894 73.45 23.1099 73.45 24.2886V29.7715H72.0342V19.3221H73.3902V21.2491C73.7757 20.6134 74.3075 20.1234 74.9854 19.7791C75.6767 19.4215 76.4744 19.2427 77.3784 19.2427Z"
            fill="#F47342" />
          <path fill-rule="evenodd" clip-rule="evenodd"
            d="M74.0679 20.4143C74.3362 20.1652 74.6421 19.9534 74.9854 19.7791C75.6767 19.4215 76.4744 19.2427 77.3784 19.2427C78.6945 19.2427 79.738 19.6267 80.5091 20.3949C81.2934 21.1498 81.6856 22.2556 81.6856 23.7125V29.7715H80.2698V23.8515C80.2698 22.7655 79.9973 21.9378 79.4522 21.3683C78.9072 20.7988 78.1295 20.5141 77.1191 20.5141C75.9891 20.5141 75.0918 20.8518 74.4271 21.5272C73.7757 22.1894 73.45 23.1099 73.45 24.2886V29.7715H72.0342V19.3221H73.3902V21.2491C73.5805 20.9353 73.8064 20.6571 74.0679 20.4143ZM74.0679 19.5429V19.3221C74.0679 18.9478 73.7645 18.6444 73.3902 18.6444H72.0342C71.6599 18.6444 71.3564 18.9478 71.3564 19.3221V29.7715C71.3564 30.1458 71.6599 30.4493 72.0342 30.4493H73.45C73.8243 30.4493 74.1277 30.1458 74.1277 29.7715V24.2886C74.1277 23.2376 74.4147 22.5063 74.9102 22.0026M74.0679 19.5429C74.2586 19.4075 74.4615 19.2852 74.6763 19.1759C75.4777 18.7619 76.3845 18.5649 77.3784 18.5649C78.8316 18.5649 80.0599 18.9931 80.9833 19.9107C81.9378 20.8319 82.3634 22.1384 82.3634 23.7125V29.7715C82.3634 30.1458 82.0599 30.4493 81.6856 30.4493H80.2698C79.8955 30.4493 79.5921 30.1458 79.5921 29.7715V23.8515C79.5921 22.8733 79.3475 22.2391 78.9626 21.8369C78.579 21.4361 77.9995 21.1918 77.1191 21.1918C76.1333 21.1918 75.4233 21.4812 74.9102 22.0026"
            fill="#F47342" />
          <path
            d="M61.9777 29.4591L61.9777 29.4591L61.9814 29.4611C62.8367 29.9409 63.7933 30.1779 64.8434 30.1779C65.8934 30.1779 66.85 29.9409 67.7053 29.4611L67.7053 29.4612L67.709 29.4591C68.5618 28.9666 69.2286 28.2888 69.7046 27.4302C70.195 26.5692 70.4368 25.5999 70.4368 24.5309C70.4368 23.462 70.195 22.4926 69.7046 21.6317C69.2281 20.7722 68.5601 20.1001 67.7053 19.6205C66.85 19.1408 65.8934 18.9038 64.8434 18.9038C63.7933 18.9038 62.8367 19.1408 61.9814 19.6205C61.1268 20.0999 60.4529 20.7715 59.9635 21.6298C59.4724 22.4913 59.2302 23.4612 59.2302 24.5309C59.2302 25.6007 59.4724 26.5706 59.9635 27.432C60.4524 28.2895 61.1252 28.9668 61.9777 29.4591ZM66.6381 21.2769L66.6381 21.277L66.646 21.2814C67.1771 21.5784 67.5907 22.0049 67.8894 22.57C68.1884 23.1358 68.3421 23.7867 68.3421 24.5309C68.3421 25.2752 68.1884 25.926 67.8894 26.4919C67.5903 27.0577 67.1755 27.4921 66.642 27.8025C66.1215 28.0999 65.5249 28.2524 64.8434 28.2524C64.1631 28.2524 63.5596 28.1005 63.025 27.8025C62.5051 27.4924 62.0891 27.0575 61.7764 26.4894C61.4782 25.9242 61.3249 25.2741 61.3249 24.5309C61.3249 23.7878 61.4782 23.1377 61.7764 22.5725C62.0893 22.0041 62.505 21.5765 63.0239 21.2798L63.0239 21.2798L63.026 21.2786C63.5608 20.9676 64.1638 20.8095 64.8434 20.8095C65.523 20.8095 66.1181 20.9676 66.6381 21.2769Z"
            fill="#F47342" stroke="#F47342" stroke-width="0.677734" stroke-linejoin="round" />
          <path
            d="M49.5442 26.1347L57.6975 24.5467C57.8601 24.515 57.9759 24.3704 57.9714 24.2048C57.9437 23.1898 57.6931 22.2746 57.2131 21.4678C56.7483 20.6643 56.1121 20.0339 55.3085 19.5817C54.515 19.1278 53.626 18.9038 52.6498 18.9038C51.6079 18.9038 50.6651 19.141 49.8308 19.6226C48.9985 20.103 48.3424 20.7754 47.8652 21.6329L47.8652 21.6329L47.8631 21.6366C47.3986 22.4969 47.1699 23.4643 47.1699 24.5309C47.1699 25.601 47.4133 26.5711 47.9068 27.4326C48.3996 28.2929 49.0908 28.9703 49.9738 29.4617L49.9738 29.4617L49.9775 29.4637C50.8636 29.9427 51.8694 30.1779 52.986 30.1779C53.8566 30.1779 54.6602 30.0254 55.3921 29.7153C56.1257 29.4044 56.7436 28.9499 57.2407 28.3524C57.3469 28.2247 57.3449 28.0389 57.2361 27.9135L56.4451 27.0024C56.3804 26.9279 56.2864 26.8853 56.1876 26.8857C56.0889 26.8862 55.9952 26.9297 55.9312 27.0049C55.584 27.4127 55.1595 27.7248 54.6535 27.9423C54.1588 28.1475 53.6109 28.2524 53.0057 28.2524C52.1031 28.2524 51.3423 28.0307 50.708 27.6001C50.1863 27.2275 49.7986 26.7418 49.5442 26.1347ZM50.8628 21.2586L50.8628 21.2587L50.8649 21.2574C51.3887 20.9474 51.9808 20.7897 52.6498 20.7897C53.5113 20.7897 54.2205 21.0486 54.7989 21.557L54.7989 21.5571L54.8019 21.5596C55.3043 21.991 55.644 22.5265 55.8215 23.1756L49.2121 24.4604C49.212 24.4511 49.212 24.4416 49.212 24.4319C49.212 23.7001 49.3602 23.0702 49.6462 22.5325C49.9477 21.9772 50.3529 21.5556 50.8628 21.2586Z"
            fill="#F47342" stroke="#F47342" stroke-width="0.677734" stroke-linejoin="round" />
          <path
            d="M32.4788 15.5967C32.2916 15.5967 32.1399 15.7484 32.1399 15.9355V29.7715C32.1399 29.9587 32.2916 30.1104 32.4788 30.1104H38.1328C39.6462 30.1104 40.9971 29.8113 42.1765 29.203L42.1765 29.203L42.1793 29.2016C43.3557 28.581 44.2758 27.7216 44.9308 26.6246L44.9318 26.623C45.5871 25.5117 45.9112 24.252 45.9112 22.8535C45.9112 21.4555 45.5873 20.2019 44.9313 19.103C44.2764 17.9927 43.3559 17.1324 42.1779 16.5245C40.9982 15.9026 39.6468 15.5967 38.1328 15.5967H32.4788ZM43.078 20.0997L43.0779 20.0997L43.0791 20.1017C43.5466 20.8861 43.7852 21.7998 43.7852 22.8535C43.7852 23.9067 43.5468 24.8276 43.0786 25.6261C42.6096 26.4126 41.9496 27.0353 41.0895 27.4952C40.2336 27.9397 39.2249 28.1677 38.0534 28.1677H34.2857V17.5394H38.0534C39.2243 17.5394 40.2323 17.7737 41.0878 18.2308L41.0878 18.2308L41.0912 18.2326C41.9493 18.6786 42.6088 19.3002 43.078 20.0997Z"
            fill="#F47342" stroke="#F47342" stroke-width="0.677734" stroke-linejoin="round" />
          <path
            d="M32.456 12V6.4H35.728C36.0587 6.4 36.36 6.47733 36.632 6.632C36.9093 6.78133 37.1307 6.98667 37.296 7.248C37.4613 7.50933 37.544 7.8 37.544 8.12C37.544 8.456 37.4533 8.76267 37.272 9.04C37.0907 9.312 36.8507 9.53067 36.552 9.696C36.2533 9.856 35.9253 9.936 35.568 9.936H33.32V12H32.456ZM33.32 9.104H35.488C35.6907 9.104 35.8773 9.05867 36.048 8.968C36.224 8.87733 36.3627 8.75733 36.464 8.608C36.5707 8.45867 36.624 8.296 36.624 8.12C36.624 7.95467 36.5707 7.80533 36.464 7.672C36.3627 7.53867 36.224 7.432 36.048 7.352C35.8773 7.272 35.6907 7.232 35.488 7.232H33.32V9.104ZM42.953 12.08C42.457 12.08 42.0037 12.008 41.593 11.864C41.1823 11.7147 40.825 11.5093 40.521 11.248C40.217 10.9813 39.9823 10.6747 39.817 10.328C39.6517 9.976 39.569 9.6 39.569 9.2C39.569 8.8 39.6517 8.42667 39.817 8.08C39.9823 7.728 40.217 7.42133 40.521 7.16C40.825 6.89333 41.1823 6.688 41.593 6.544C42.0037 6.39467 42.457 6.32 42.953 6.32C43.4437 6.32 43.8943 6.39467 44.305 6.544C44.7157 6.688 45.073 6.89333 45.377 7.16C45.681 7.42133 45.9157 7.728 46.081 8.08C46.2517 8.42667 46.337 8.8 46.337 9.2C46.337 9.6 46.2517 9.976 46.081 10.328C45.9157 10.6747 45.681 10.9813 45.377 11.248C45.073 11.5093 44.7157 11.7147 44.305 11.864C43.8943 12.008 43.4437 12.08 42.953 12.08ZM42.953 11.24C43.321 11.24 43.657 11.1893 43.961 11.088C44.265 10.9813 44.529 10.8373 44.753 10.656C44.977 10.4693 45.1503 10.2533 45.273 10.008C45.3957 9.75733 45.457 9.488 45.457 9.2C45.457 8.912 45.3957 8.64533 45.273 8.4C45.1503 8.14933 44.977 7.93333 44.753 7.752C44.529 7.56533 44.265 7.42133 43.961 7.32C43.657 7.21333 43.321 7.16 42.953 7.16C42.585 7.16 42.2463 7.21333 41.937 7.32C41.633 7.42133 41.369 7.56533 41.145 7.752C40.921 7.93333 40.7477 8.14933 40.625 8.4C40.5077 8.64533 40.449 8.912 40.449 9.2C40.449 9.488 40.5077 9.75733 40.625 10.008C40.7477 10.2533 40.921 10.4693 41.145 10.656C41.369 10.8373 41.633 10.9813 41.937 11.088C42.2463 11.1893 42.585 11.24 42.953 11.24ZM50.0384 12L47.9744 6.4H48.9264L50.1104 9.688C50.1531 9.80533 50.1958 9.93067 50.2384 10.064C50.2811 10.1973 50.3238 10.3333 50.3664 10.472C50.4091 10.6053 50.4491 10.736 50.4864 10.864C50.5238 10.9867 50.5584 11.1013 50.5904 11.208L50.2384 11.2C50.2918 11.056 50.3504 10.8987 50.4144 10.728C50.4838 10.552 50.5558 10.376 50.6304 10.2C50.7051 10.0187 50.7771 9.848 50.8464 9.688L51.8784 7.368H52.7104L53.7104 9.672C53.7798 9.82133 53.8491 9.984 53.9184 10.16C53.9931 10.336 54.0624 10.5067 54.1264 10.672C54.1958 10.8373 54.2464 10.9893 54.2784 11.128L53.9584 11.184C53.9851 11.0933 54.0118 11 54.0384 10.904C54.0704 10.8027 54.1024 10.6987 54.1344 10.592C54.1664 10.48 54.2011 10.3707 54.2384 10.264C54.2758 10.152 54.3131 10.0427 54.3504 9.936C54.3931 9.82933 54.4331 9.728 54.4704 9.632L55.7824 6.4H56.7104L54.4064 12H53.8064L52.1824 8.232L52.3344 8.264L50.7024 12H50.0384ZM58.8254 12V6.4H63.4734V7.232H59.6894V11.168H63.4734V12H58.8254ZM59.2974 9.544V8.712H63.0334V9.544H59.2974ZM66.1282 12V6.4H69.4002C69.7309 6.4 70.0322 6.47733 70.3042 6.632C70.5815 6.78133 70.8029 6.98667 70.9682 7.248C71.1335 7.50933 71.2162 7.8 71.2162 8.12C71.2162 8.456 71.1255 8.76267 70.9442 9.04C70.7629 9.312 70.5229 9.53067 70.2242 9.696C69.9255 9.856 69.5975 9.936 69.2402 9.936H66.9922V12H66.1282ZM70.4642 12L68.5602 9.472L69.4802 9.272L71.5442 12.008L70.4642 12ZM66.9922 9.104H69.1602C69.3629 9.104 69.5495 9.05867 69.7202 8.968C69.8962 8.87733 70.0349 8.75733 70.1362 8.608C70.2429 8.45867 70.2962 8.296 70.2962 8.12C70.2962 7.95467 70.2429 7.80533 70.1362 7.672C70.0349 7.53867 69.8962 7.432 69.7202 7.352C69.5495 7.272 69.3629 7.232 69.1602 7.232H66.9922V9.104ZM74.1341 12V6.4H78.7821V7.232H74.9981V11.168H78.7821V12H74.1341ZM74.6061 9.544V8.712H78.3421V9.544H74.6061ZM81.4369 12V6.4H84.2689C84.7809 6.4 85.2316 6.47467 85.6209 6.624C86.0156 6.77333 86.3463 6.97867 86.6129 7.24C86.8796 7.496 87.0796 7.792 87.2129 8.128C87.3463 8.464 87.4129 8.82133 87.4129 9.2C87.4129 9.584 87.3463 9.94667 87.2129 10.288C87.0796 10.624 86.8796 10.92 86.6129 11.176C86.3463 11.432 86.0156 11.6347 85.6209 11.784C85.2316 11.928 84.7809 12 84.2689 12H81.4369ZM82.3009 11.256L82.2769 11.168H84.2289C84.6289 11.168 84.9703 11.1173 85.2529 11.016C85.5409 10.9147 85.7756 10.7733 85.9569 10.592C86.1383 10.4107 86.2716 10.2027 86.3569 9.968C86.4476 9.728 86.4929 9.472 86.4929 9.2C86.4929 8.93333 86.4476 8.68267 86.3569 8.448C86.2716 8.21333 86.1383 8.00533 85.9569 7.824C85.7756 7.63733 85.5409 7.49333 85.2529 7.392C84.9703 7.28533 84.6289 7.232 84.2289 7.232H82.2529L82.3009 7.16V11.256ZM93.6129 12V6.4H96.6689C97.1382 6.4 97.5302 6.456 97.8449 6.568C98.1595 6.67467 98.3969 6.832 98.5569 7.04C98.7169 7.248 98.7969 7.504 98.7969 7.808C98.7969 8.10133 98.6982 8.35733 98.5009 8.576C98.3035 8.78933 98.0155 8.94133 97.6369 9.032L97.6929 8.88C97.9329 8.93333 98.1595 9.01867 98.3729 9.136C98.5862 9.25333 98.7595 9.41333 98.8929 9.616C99.0262 9.81333 99.0929 10.0587 99.0929 10.352C99.0929 10.6773 99.0262 10.9467 98.8929 11.16C98.7649 11.3733 98.5915 11.5413 98.3729 11.664C98.1595 11.7867 97.9222 11.8747 97.6609 11.928C97.3995 11.976 97.1382 12 96.8769 12H93.6129ZM94.4769 11.168H96.9089C97.1649 11.168 97.3889 11.1387 97.5809 11.08C97.7782 11.0213 97.9329 10.9307 98.0449 10.808C98.1569 10.68 98.2129 10.5227 98.2129 10.336C98.2129 10.1227 98.1435 9.95733 98.0049 9.84C97.8662 9.72267 97.6929 9.64 97.4849 9.592C97.2769 9.53867 97.0715 9.512 96.8689 9.512H94.4769V11.168ZM94.4769 8.672H96.8289C97.0209 8.672 97.1995 8.64267 97.3649 8.584C97.5302 8.52533 97.6609 8.44 97.7569 8.328C97.8582 8.216 97.9089 8.08533 97.9089 7.936C97.9089 7.68 97.7942 7.49867 97.5649 7.392C97.3409 7.28533 97.0635 7.232 96.7329 7.232H94.4769V8.672ZM103.338 12V9.496L103.498 10.112L100.49 6.4H101.69L103.874 9.224H103.69L105.818 6.4H106.89L104.162 9.896L104.202 9.432V12H103.338Z"
            fill="#F47342" />
          <defs>
            <filter id="filter0_d_1011_1226" x="8.82275" y="11.0513" width="10.7756" height="11.7992"
              filterUnits="userSpaceOnUse" color-interpolation-filters="sRGB">
              <feFlood flood-opacity="0" result="BackgroundImageFix" />
              <feColorMatrix in="SourceAlpha" type="matrix" values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
                result="hardAlpha" />
              <feOffset dy="1.0238" />
              <feComposite in2="hardAlpha" operator="out" />
              <feColorMatrix type="matrix" values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.08 0" />
              <feBlend mode="normal" in2="BackgroundImageFix" result="effect1_dropShadow_1011_1226" />
              <feBlend mode="normal" in="SourceGraphic" in2="effect1_dropShadow_1011_1226" result="shape" />
            </filter>
            <linearGradient id="paint0_linear_1011_1226" x1="29.543" y1="21.3115" x2="1.09083" y2="20.8511"
              gradientUnits="userSpaceOnUse">
              <stop stop-color="#D85828" />
              <stop offset="1" stop-color="#E06334" />
            </linearGradient>
          </defs>
        </svg>

      </a>
    </div>
  </div>
  </div>
</template>
<script>
import { mapActions, mapGetters } from "vuex";

export default {
  props: ['user', "walletAmount"],
  data() {
    return {
      menus: [],
      terms_url: null,
      privacypolicy_url: null,
      help_url: null,
      setting: null,
      is_support: false,
      email: null,
      phone: null,
      whatsapp: null,
      iswalletDisplay: false,
      mywalletAmount: 0,
      nosupport: true,
    };
  },

  computed: {
    ...mapGetters("user", ["userWallet", "getUserWallet"]),
    // waller_data() {
    //   return this.$auth.user.data ? this.$auth.user.data.wallet_amount : this.$auth.user.wallet_amount;
    // }
  },

  mounted() {
    setTimeout(() => {
      this.setting = this.$auth.setting;
      this.setStaticPages();
      if (this.$auth.user) {
        this.$auth.setUser();
        // this.getProfile()
        // this.mywalletAmount = this.$auth.user.wallet_amount; //(this.$auth.userWalletAmount && this.$auth.userWalletAmount != null && this.$auth.userWalletAmount != '' ? this.$auth.userWalletAmount:this.userWallet);        
        // this.mywalletAmount = this.walletAmount;
        // this.mywalletAmount = this.$auth.user && this.$auth.user.data && this.$auth.user.data.wallet_amount;
      }
    }, 1000);
  },

  methods: {
    ...mapActions("user", ["checkLogout", "GetUserProfile"]),

    LogOut() {
      if (confirm(this.$t("Are you sure you want to Signout?"))) {
        let logoutData = {
          user_id: this.$auth.user.user_id,
          device_type: "web",
          devicetoken: this.$auth.user.token,
          unquie_id: "",
        }
        this.$auth.logout(logoutData, (callback) => {
          this.$store.commit('product/clearCartItems')
          localStorage.removeItem('place_order_data');
          // const vuex = JSON.parse(localStorage.getItem('vuex'));
          // if (vuex.address) {
          //   localStorage.removeItem('vuex');
          // }
          this.$router.push({ name: callback }).catch(() => { });
        });
      }
    },

    sideMenu() {
      this.menus = [
        {
          title: "Home",
          link: "home",
          isAuthRequired: true
        },
        {
          title: "Login",
          link: "sign-in",
          isAuthRequired: (this.$auth.user) ? true : false
        },
        {
          title: "Delivery Address",
          link: "address",
          isAuthRequired: (this.$auth.user) ? true : false
        },
        {
          title: "Orders",
          link: "orders",
          isAuthRequired: (this.$auth.user) ? true : false
        },
        {
          title: "My Profile",
          link: "profile",
          isAuthRequired: (this.$auth.user) ? true : false
        },
        {
          title: "Promocode",
          link: "promo-code",
          isAuthRequired: true
        },
        {
          title: "pages",
          link: "pages",
          isAuthRequired: true
        },
        {
          title: "FAQ",
          link: "faq",
          isAuthRequired: true
        },
        {
          title: "PrivacyPolicy",
          link: "privacypolicy",
          isAuthRequired: true
        },
      ];
    },

    setStaticPages() {
      if (this.setting) {
        if (this.setting.pages && this.setting.pages.length > 0) {
          for (let index = 0; index < this.setting.pages.length; index++) {
            if (this.setting.pages[index].privacypolicy_url) {
              this.privacypolicy_url = this.setting.pages[index].privacypolicy_url;
            } else if (this.setting.pages[index].help_url) {
              this.help_url = this.setting.pages[index].help_url;
            } else if (this.setting.pages[index].terms_url) {
              this.terms_url = this.setting.pages[index].terms_url;
            }
          }
        }
        if (this.setting.support_field && this.setting.support_field.length > 0) {
          if (this.setting.support_field[0]) {
            if (this.setting.support_field[0].phone || this.setting.support_field[0].whatsapp || this.setting.support_field[0].email) {
              this.is_support = true;
            }
            if (this.setting.support_field && !this.setting.support_field[0].phone && !this.setting.support_field[0].whatsapp && !this.setting.support_field[0].email) {
              this.nosupport = false;
            }
          }

        }
      }
    }
  },
};

</script>